export const environment = {
  production: true,
  apiUrl: "https://app-woodcareplanner-eastus2-stg-002-fgavcthxebh4f8b7.eastus2-01.azurewebsites.net/api",
  name: "stg",
  siteName: 'ppsstainselector',
  facebookUrl: 'http://ppsstainapp-app-stg.ppgac.com',
  pinterestUrl: 'http://pps11stg.ppgac.com/woodcareplanner'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts